/**
 * Resources Page
 *
 * Container, vehicle, and driver management.
 * PURELY PRESENTATIONAL - placeholder for Phase 3 implementation.
 */

import { PageHeader } from '@/components/service-provider/PageHeader';
import { Outlet, useLocation } from 'react-router-dom';

export function ResourcesPage() {
  const location = useLocation();
  const isRoot = location.pathname === '/provider/dashboard/resources';

  return (
    <div>
      <PageHeader
        title="Resources"
        description="Manage containers, vehicles, and drivers"
        breadcrumbs={[
          { label: 'Dashboard', href: '/provider/dashboard' },
          { label: 'Resources' },
        ]}
      />

      {isRoot ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <ResourceCard
            title="Containers"
            description="Inventory tracking and location management"
            href="/provider/dashboard/resources/containers"
          />
          <ResourceCard
            title="Vehicles"
            description="Fleet status and maintenance records"
            href="/provider/dashboard/resources/vehicles"
          />
          <ResourceCard
            title="Drivers"
            description="Schedule and certification management"
            href="/provider/dashboard/resources/drivers"
          />
        </div>
      ) : (
        <Outlet />
      )}
    </div>
  );
}

function ResourceCard({
  title,
  description,
  href,
}: {
  title: string;
  description: string;
  href: string;
}) {
  return (
    <a href={href} className="card hover:shadow-md transition-shadow">
      <div className="card-content">
        <h3 className="text-lg font-semibold text-neutral-900 mb-2">{title}</h3>
        <p className="text-sm text-neutral-600">{description}</p>
        <p className="text-sm text-primary-600 mt-4">View Details →</p>
      </div>
    </a>
  );
}
